import { 
  RESET_CAMERA, 
  SET_AXIS_POSITION, 
  SET_AXIS_ORIENTATION, 
  SET_CAMERA_STATE, 
  RESET_CAMERA_STATE, 
  SET_PERSPECTIVE_CAMERA,
  SET_PERSPECTIVE_CAMERA_TYPE
} from '@reducers/camera/actions';
import { APP_TYPES } from '@config';

import generalCalculationDefault from './defaults/generalCalculation';
import bracketAttachmentDefault from './defaults/bracketAttachment';
import safetyBarrierDefault from './defaults/safetyBarrier';
import rebarReinforcementDefault from './defaults/rebarReinforcement';
import woodConnectionDefault from './defaults/woodConnection';

import { mergeDeep } from '@services/helper.service';

const initState = {
  ...generalCalculationDefault
};

const camera = (state = initState, action) => {
  switch (action.type) {
    case RESET_CAMERA: {
      switch (action.appType) {
        case APP_TYPES.GENERAL_CALCULATION: {
          return mergeDeep({}, generalCalculationDefault, { mode: action.mode });
        }
        case APP_TYPES.BRACKET_ATTACHMENT: {
          return mergeDeep({}, bracketAttachmentDefault, { mode: action.mode });
        }
        case APP_TYPES.SAFETY_BARRIER: {
          return mergeDeep({}, safetyBarrierDefault, { mode: action.mode });
        }
        case APP_TYPES.REBAR_REINFORCEMENT: {
          return mergeDeep({}, rebarReinforcementDefault, { mode: action.mode });
        }
        case APP_TYPES.WOOD_CONNECTION: {
          return mergeDeep({}, woodConnectionDefault, { mode: action.mode });
        }
        default: {
          return state;
        }
      }
    }
    case SET_AXIS_POSITION: {
      state.axis.position = action.position;

      return { ...state };
    }
    case SET_AXIS_ORIENTATION: {
      return mergeDeep({}, state, {
        axis: {
          orientation3D: action.orientation.orientation3D || state.axis.orientation3D,
          orientation2D: action.orientation.orientation2D || state.axis.orientation2D,
        }
      });
    }
    case RESET_CAMERA_STATE: {
      return initState;
    }
    case SET_CAMERA_STATE: {
      return action.state;
    }
    case SET_PERSPECTIVE_CAMERA: {
      return mergeDeep({}, state, { 
        perspectiveCamera: mergeDeep({}, state.perspectiveCamera, action.options)
      });
    }
    case SET_PERSPECTIVE_CAMERA_TYPE: {
      return mergeDeep({}, state, {
        perspectiveCameraType: action.value
      });
    }
    default: {
      return state;
    }
  }
};

export default camera;



// WEBPACK FOOTER //
// ./src/reducers/camera/index.js